import { PcsSurescriptSignatureInfo } from './PcsSurescriptSignatureInfo';

export class EXOAuthTransaction
{
    facilityId : any;
    type :  string ;
    providerId : string ;
    otp : string ;
    userId : string ;
    password : string ;
    loggedInUser : string ;
    provderid :  string ;
    LocationName :  string ;
    facilityName : string;
    eRxId: number;
    inputErx: PcsSurescriptSignatureInfo[];
    reqId : number;
    locationId: number; 
}